// extracted by mini-css-extract-plugin
export default {"input":"Q9-z","button":"R9-z","selected":"S9-z","unavailable":"T9-z","oos":"U9-z","image":"V9-z","paperCutDisabledOverlay":"W9-z"};